import overrideTableStyles from './Table';
import overrideDialogStyles from './Dialog';
import overrideComponentStyles from './Components';


const overrideComponents = theme => Object.assign(
	overrideTableStyles(theme),
	overrideDialogStyles(theme),
	overrideComponentStyles(theme)
)

export default overrideComponents;